import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencilLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPencilLine"><Path d="M2.75 21.2555V18.2482C2.75 17.4525 3.06607 16.6895 3.62868 16.1268L16.1287 3.62684C17.3003 2.45527 19.2034 2.45895 20.375 3.63052C21.5466 4.80209 21.5502 6.70527 20.3787 7.87684L7.87868 20.3768C7.31607 20.9395 6.55301 21.2555 5.75736 21.2555H2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M12.75 21.2555H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconPencilLine;
